module.exports = __webpack_public_path__ + "media/images/landing_page/kazu_uzdevumi-fa29053300b004793c55c2bcab837dd4.png";